import React, { useEffect } from "react";

export default function Modal2({ children, onClose }) {
  const handleOverlayClick = () => {
    if (onClose) onClose();
  };

  const handleEsc = (e) => {
    if (e.key === "Escape" && onClose) onClose();
  };

  useEffect(() => {
    window.addEventListener("keydown", handleEsc);
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div
      style={overlayStyle}
      onClick={handleOverlayClick}
    >
      <div
        style={containerStyle}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0,0,0,0.55)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999
};

const containerStyle = {
  backgroundColor: "#fff",
  borderRadius: "16px",
  padding: "20px",
  width: "90%",
  maxWidth: "350px",
  boxShadow: "0 10px 25px rgba(0,0,0,0.25)"
};
